<template>
  <v-card :max-width="maxWidth">
    <v-stepper v-model="step">
      <v-stepper-header>
        <v-stepper-step step="1">
          <small class="small">{{ mode }}</small>
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="2">
          <small class="small">{{ $t("concepts.stepperHeaderStep2") }}</small>
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="3">
          <small class="small">{{ $t("concepts.stepperHeaderStep3") }}</small>
        </v-stepper-step>
      </v-stepper-header>
    </v-stepper>
    <v-form ref="form" v-model="valid" class="form-container pa-4">
      <v-alert
        v-if="error"
        color="red"
        elevation="5"
        outlined
        text
        type="error"
        align="center"
        class="mx-1 mb-5"
      >
        {{ alertValidate }}
      </v-alert>

      <template v-if="step === 1">
        <div
          class="ma-0"
          v-for="(input, index) in inputsForm"
          :key="'input_' + index + input.name"
        >
          <v-text-field
            :name="input.name"
            v-model="input.data"
            :label="input.label"
            outlined
            :rules="input.rules"
            :hide-details="valid"
            dense
            class="ma-0"
          />
        </div>
        <div
          v-for="(checkbox, index) in checkboxes"
          :key="'checkbox_' + index + checkbox.name"
          class="d-block ma-0"
        >
          <v-checkbox
            v-model="checkbox.data"
            :name="checkbox.name"
            hide-details
            dense
            :disabled="isCheckboxDisabled(checkbox)"
            class="my-1"
          >
            <template v-slot:label>
              <span style="font-size: 18px">{{ checkbox.label }}</span>
            </template></v-checkbox
          >
        </div>
        <div class="container-buttons mt-2">
          <div>
            <v-btn class="bt-exit mr-2" @click="cancel">{{
              $tc("editRegistrations.cancel")
            }}</v-btn>
            <v-btn @click="nextStep" class="bt-next" :disabled="!valid">{{
              $tc("concepts.next")
            }}</v-btn>
          </div>
          <v-btn @click="submitForm" :disabled="!valid" class="bt-acept">{{
            buttonText
          }}</v-btn>
        </div>
      </template>

      <template v-if="step === 2">
        <template v-if="modelsLiquidation[0].items.length === 0">
          <p class="text-center">{{ $tc("concepts.alertLiquidations") }}</p>
          <div class="container-buttons">
            <v-btn class="bt-exit" @click="cancel">{{
              $tc("editRegistrations.cancel")
            }}</v-btn>
            <div>
              <v-btn @click="prevStep" class="bt-previous">{{
                $tc("concepts.previous")
              }}</v-btn>
              <v-btn @click="nextStep" class="bt-next" :disabled="!valid">{{
                $tc("concepts.next")
              }}</v-btn>
            </div>
          </div>
        </template>

        <template v-else>
          <div v-if="isEdit === true" height="100" class="mb-2 mx-n2">
            <Table
              :items="itemsEditLiquidations"
              :title="title"
              :headers="headersLiquidations"
              :openDialog="openDialogLiquidations"
              @headersUpdated="updateHeadersLiquidaciones"
              @refreshItems="refreshItems"
              :showRefresh="true"
            />
          </div>

          <div v-if="isEdit === false">
            <v-checkbox
              v-model="authAll.data"
              :label="authAll.label"
              :name="authAll.name"
              :value="authAll.data"
              class="mt-1"
            />
            <div
              v-for="(select, name) in itemsLiquidations"
              :key="'input_' + name + select.name"
              v-show="show"
            >
              <v-select
                :name="select.name"
                :items="select.items"
                :item-text="select.itemsText"
                :item-value="select.itemsValue"
                v-model="select.data"
                :label="select.label"
                :rules="select.rules"
                outlined
                :multiple="multiple"
                dense
              />
            </div>
          </div>
          <div class="container-buttons">
            <v-btn class="bt-exit" @click="cancel">{{
              $tc("editRegistrations.cancel")
            }}</v-btn>
            <div>
              <v-btn @click="prevStep" class="bt-previous mr-2">{{
                $tc("concepts.previous")
              }}</v-btn>
              <v-btn @click="nextStep" class="bt-next" :disabled="!valid">{{
                $tc("concepts.next")
              }}</v-btn>
            </div>
            <v-btn @click="submitForm" class="bt-acept">{{ buttonText }}</v-btn>
          </div>
        </template>
      </template>

      <template v-if="step === 3">
        <template v-if="conceptsSalary[0].items.length === 0">
          <p class="text-center">{{ $tc("concepts.alertConcepts") }}</p>
          <div class="container-buttons">
            <v-btn @click="prevStep" class="bt-exit">{{
              $tc("concepts.previous")
            }}</v-btn>
          </div>
        </template>
        <template v-else>
          <div v-if="isEdit === false">
            <DateWithCheck v-if="showDate" class="mb-5 mt-2" />
            <div
              v-for="(select, name) in itemsSalaries"
              :key="'input_' + name + select.name"
              v-show="show"
            >
              <v-select
                :name="select.name"
                :items="select.items"
                :item-text="select.itemsText"
                :item-value="select.itemsValue"
                v-model="select.data"
                :label="select.label"
                :rules="select.rules"
                outlined
                :multiple="multiple"
                dense
              />
            </div>
          </div>
          <div v-if="isEdit === true" height="100" class="mb-2 mx-n2">
            <Table
              :items="itemsEditSalaries"
              :title="title"
              :headers="headersSalaries"
              :openDialog="openDialogSalaries"
              @headersUpdated="updateHeadersSalarios"
              @refreshItems="refreshItems"
              :showRefresh="true"
            />
          </div>
          <div class="container-buttons">
            <div>
              <v-btn @click="prevStep" class="bt-previous">{{
                $tc("concepts.previous")
              }}</v-btn>
            </div>
            <v-btn @click="submitForm" class="bt-acept">{{ buttonText }}</v-btn>
          </div>
        </template>
      </template>
    </v-form>
    <!--al editar item no se edita la fecha-->
    <v-dialog v-model="openSalaries" :max-width="'600px'" persistent>
      <Form
        :items="this.inputs"
        :itemsSelect="selectsData"
        @save="save"
        @cancel="reset"
        :maxWidth="'600px'"
        :show="true"
        :mode="modeSalaries"
        :showDate="true"
        :showCheck="true"
      />
    </v-dialog>
    <v-dialog v-model="openLiquidations" :max-width="'600px'" persistent>
      <Form
        :itemsSelect="selectDataLiquidations"
        :itemsCheckbox="checkAuthLiquidations"
        @save="saveLiquidations"
        @cancel="resetLiquidation"
        :maxWidth="'600px'"
        :show="true"
        :mode="modeLiquidation"
      />
    </v-dialog>
    <DeleteDialog
      :showDialog="openDeleteSalaries"
      :title="titleDeleteSalarie"
      :confirmDelete="deleteItem"
      :cancelDelete="cancelDelete"
      :maxWidth="'500px'"
    />
    <DeleteDialog
      :showDialog="openDeleteLiquidations"
      :title="titleDeleteLiquidation"
      :confirmDelete="deleteItemLiquidation"
      :cancelDelete="cancelDeleteLiquidation"
      :maxWidth="'500px'"
    />
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-card>
</template>

<script>
import DateWithCheck from "@/components/Complement/DateWithCheck.vue";
import Table from "@/components/Complement/TableWithSearch.vue";
import Vue from "vue";
import concept from "@/models/workflow/concept";
import concepts from "@/store/conceptos/concepts";
import date from "@/store/common/date";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import Form from "@/components/Complement/Form.vue";
import moment from "moment";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: { DateWithCheck, Table, DeleteDialog, Snackbar, Form },
  props: {
    items: {
      type: Array,
    },
    maxWidth: String,
    mode: String,
    show: {
      type: Boolean,
      default: false,
    },
    showDate: Boolean,
    itemsCheckbox: Array,
    itemsLiquidations: Array,
    itemsSalaries: Array,
    itemsSelect: Array,
    multiple: Boolean,
  },
  data() {
    return {
      authAll: {
        name: "authAll",
        label: this.$tc("concepts.authAllLiquidation"),
        data: true,
      },
      authorizeLiquidations: true,
      inputsForm: [],
      valid: true,
      error: false,
      alertValidate: "",
      checkboxes: [],
      modelsLiquidation: [],
      conceptsSalary: [],
      step: 1,
      tempData: {},
      selectedModels: [],
      conceptsSelected: [],
      disableNext: true,
      title: "",
      titleTable: "Conceptos_y_Relaciones",
      checkAuthLiquidations: [
        {
          name: "auth",
          label: this.$tc("concepts.authLiquidation"),
          data: true,
        },
      ],
      titleDeleteSalarie: this.$tc("concepts.toSalarie"),
      titleDeleteLiquidation: this.$tc("concepts.toLiquidation"),
      color: "#82A1D0",
      alert: false,
      textAlert: "",
      inputs: [],
      originalData: {},
    };
  },
  async created() {
    concepts.dispatch("getLiquidationModels");
    this.inputsForm = Vue.observable(this.items);
    this.checkboxes = Vue.observable(this.itemsCheckbox);
    this.modelsLiquidation = Vue.observable(this.itemsLiquidations);
    this.conceptsSalary = Vue.observable(this.itemsSalaries);
  },
  computed: {
    headersLiquidations() {
      return configTable.state.colums.liquidaciones;
    },
    headersSalaries() {
      return configTable.state.colums.salarios;
    },
    buttonText() {
      return this.mode === this.$tc("concepts.addConcept")
        ? this.$tc("commons.add")
        : this.$tc("commons.accept");
    },
    salaries() {
      return concepts.state.salaries;
    },
    liquidations() {
      return concepts.state.liquidations;
    },
    isEdit() {
      return this.mode === this.$tc("concepts.editConcept");
    },
    itemsEditSalaries() {
      return concepts.state.editConcept.cSueldos || [];
    },
    itemsEditLiquidations() {
      return concepts.state.editConcept.liqModelos || [];
    },

    modeSalaries: {
      get() {
        return concepts.state.modeSalaries;
      },
      set(newValue) {
        return newValue;
      },
    },

    modoSalaries() {
      if (this.modeSalaries === this.$tc("costCenter.addClock")) {
        return this.$tc("commons.add");
      } else {
        return this.$tc("commons.edit");
      }
    },
    openSalaries: {
      get() {
        return concepts.state.openSalaries;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    openDeleteSalaries: {
      get() {
        return concepts.state.openDeleteSalaries;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    openLiquidations: {
      get() {
        return concepts.state.openLiquidations;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    modeLiquidation: {
      get() {
        return concepts.state.modeLiquidations;
      },
      set(newValue) {
        return newValue;
      },
    },

    modoLiquidations() {
      if (this.modeLiquidation === this.$tc("concept.addLiquidation")) {
        return this.$tc("commons.add");
      } else {
        return this.$tc("commons.edit");
      }
    },
    openDeleteLiquidations: {
      get() {
        return concepts.state.openDeleteLiquidations;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    selectDataLiquidations() {
      return [
        {
          autorizar: true,
          name: "liqModelos",
          label: this.$tc("concepts.modelsLiquidation"),
          data: [],
          items: this.liquidations,
          itemsValue: "liqmodelId",
          itemsText: "name",
          readonly: false,
        },
      ];
    },
    selectsData() {
      return [
        {
          name: "idSalarie",
          label: this.$tc("concepts.conceptsSalaries"),
          data: [],
          items: this.salaries,
          itemsValue: "id",
          itemsText: "name",
          itemValueFunction: (item) => `${item.id}-${item.name}`,
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
          icon: "mdi-pencil",
          readonly: false,
        },
      ];
    },
  },
  methods: {
    async refreshItems() {
      if (concepts.state.editConcept.conceptoId) {
        await concepts.dispatch(
          "getConceptId",
          concepts.state.editConcept.conceptoId
        );
      }
    },
    updateHeadersLiquidaciones(headers) {
      const updatedColums = {
        ...configTable.state.colums,
        liquidaciones: headers,
      };

      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    updateHeadersSalarios(headers) {
      const updatedColums = { ...configTable.state.colums, salarios: headers };

      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (columnsToSave === undefined || this.allHeaders.length !== this.headers.length  || columnsToSave.length === 0) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    saveSelectedConcepts() {
      this.conceptsSelected = this.conceptsSalary[0].items.filter(
        (item) => item.data
      );
    },
    submitForm(e) {
      this.saveTemporaryData();
      this.saveSelectedConcepts();
      e.preventDefault();
      this.validation(this.$refs.form.$el);
    },
    handleSubmit(form) {
      const formData = new FormData(form);
      const itemsComplete = {};

      for (let [name, value] of formData) {
        itemsComplete[name] = value;
      }

      const mergedData = { ...itemsComplete, ...this.getTemporaryData() };
      this.$refs.form.resetValidation();
      this.$emit("save", mergedData);
      this.step = 1;
    },
    cancel() {
      this.$refs.form.resetValidation();
      this.disableNext = true;
      this.step = 1;
      this.$emit("cancel", false);
    },
    validation(form) {
      let valid = this.$refs.form.validate();
      if (valid) {
        this.handleSubmit(form);
      } else {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.error = false;
        }, 3500);
      }
    },
    checkValidation() {},

    nextStep() {
      this.saveTemporaryData();
      this.step++;
    },
    prevStep() {
      this.step--;
    },
    saveTemporaryData() {
      for (let input of this.inputsForm) {
        this.tempData[input.name] = input.data;
      }
      for (let checkbox of this.checkboxes) {
        this.tempData[checkbox.name] = checkbox.data;
      }

      let idsCadena = "";

      for (let i = 0; i < this.itemsLiquidations[0].data.length; i++) {
        const id = this.itemsLiquidations[0].data[i];

        if (i > 0) {
          idsCadena += ",";
        }

        idsCadena += id;
      }

      this.tempData.liqModelos = idsCadena;
      this.tempData.authAll = this.authAll.data;
    },
    getTemporaryData() {
      this.tempData.selectedModels = this.modelsLiquidation;
      this.tempData.conceptsSelected = this.conceptsSelected;
      return { ...this.tempData };
    },
    isCheckboxDisabled(checkbox) {
      if (checkbox.name === "fullDayLicense") {
        const workHoursCheckbox = this.checkboxes.find(
          (c) => c.name === "workHours"
        );
        const roundSalaryCheckbox = this.checkboxes.find(
          (c) => c.name === "roundSalary"
        );
        return (
          (workHoursCheckbox && workHoursCheckbox.data) ||
          (roundSalaryCheckbox && roundSalaryCheckbox.data)
        );
      } else if (
        checkbox.name === "roundSalary" ||
        checkbox.name === "workHours"
      ) {
        const fullDayLicenseCheckbox = this.checkboxes.find(
          (c) => c.name === "fullDayLicense"
        );
        return fullDayLicenseCheckbox && fullDayLicenseCheckbox.data;
      }
      return false;
    },
    reset() {
      concepts.commit("setModeSalaries", "");
      concepts.commit("setOpenSalaries", false);
      concepts.commit("setOpenLiquidations", false);
    },
    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    save(items) {
      switch (this.typeForm) {
        case "add":
          this.addSalarie(items);
          break;
        case "edit":
          this.editSalarie(items);
          break;
        default:
          break;
      }
    },
    saveLiquidations(items) {
      switch (this.typeForm) {
        case "add":
          this.addLiquidation(items);
          break;
        case "edit":
          this.editLiquidation(items);
          break;
        default:
          break;
      }
    },

    addSalarie(items) {
      let payload = items;
      payload.conceptoId = concepts.state.editConcept.conceptoId;
      payload.fecDesde = date.state.dateFrom;
      if (!date.state.checkTo) {
        payload.fecHasta = date.state.dateTo;
      }
      concepts.commit("setNewConcept", payload);
      concepts
        .dispatch("addSalarie")
        .then(() => {
          concepts.commit("setOpenSalaries", false);
          this.showAlert(this.$tc("concepts.addSalarieSuccess"), "#82A1D0");
        })
        .catch((e) => {
          this.showAlert(this.$tc("concepts.addSalarieError"), "#ff8d58");
        });
      this.reset(false);
    },
    sendEdit(updatedItem) {
      concepts.commit("setEditSalaries", updatedItem);

      concepts
        .dispatch("editSalarie")
        .then(() => {
          concepts.commit("setOpenSalaries", false);
          this.showAlert(this.$tc("concepts.editSalarieSuccess"), "#82A1D0");
        })
        .catch((e) => {
          this.showAlert(this.$tc("concepts.editSalarieError"), "#ff8d58");
        });

      this.reset(false);
    },

    editSalarie(items) {
      const changes = {};
      if (Number(items.idSalarie) !== this.originalData.cSueldoId) {
        changes.idSalarie = items.idSalarie;
      }

      if (
        moment(date.state.dateFrom, "YYYY-MM-DD").format("DD-MM-YYYY") !==
        this.originalData.fecDesde
      ) {
        changes.fecDesde = date.state.dateFrom;
      }
      if (
        moment(date.state.dateTo, "YYYY-MM-DD").format("DD-MM-YYYY") !==
        this.originalData.fecHasta
      ) {
        changes.fecHasta = date.state.dateTo;
      }

      if (Object.keys(changes).length > 0) {
        const updatedItem = { ...items, ...changes };
        updatedItem.conceptId = concepts.state.editConcept.conceptoId;
        updatedItem.oldItems = this.originalData;
        updatedItem.oldItems.fecDesde = moment(
          this.originalData.fecDesde,
          "DD-MM-YYYY"
        ).format("YYYY-MM-DD");
        this.sendEdit(updatedItem);
      } else {
        concepts.commit("setOpenSalaries", false);
        this.showAlert(this.$tc("costCenter.editSalarieAlert"), "#f1c232");
      }
    },
    openEditForm(item) {
      date.state.dateFrom = moment(item.fecDesde, "DD-MM-YYYY").format(
        "YYYY-MM-DD"
      );
      if (item.fecHasta !== "") {
        date.state.dateTo = moment(item.fecHasta, "DD-MM-YYYY").format(
          "YYYY-MM-DD"
        );
        date.state.checkTo = false;
      }
      this.selectsData[0].readonly = true;
      this.selectsData[0].data = item.cSueldoId;

      concepts.commit("setOpenSalaries", true);
    },
    async openDialogSalaries(type, item) {
      this.typeForm = type;

      switch (this.typeForm) {
        case "add":
          concepts.commit("setModeSalaries", this.$tc("concepts.addSalarie"));
          concepts.commit("setOpenSalaries", true);
          break;
        case "edit":
          this.itemId = item.cSueldoId;
          this.originalData = { ...item };
          concepts.commit("setModeSalaries", this.$tc("concepts.editSalarie"));
          this.openEditForm(item);
          break;
        case "delete":
          concepts.commit("setOpenDeleteSalaries", true);
          item.fecDesde = moment(item.fecDesde, "DD-MM-YYYY").format(
            "YYYY-MM-DD"
          );
          item.conceptoId = concepts.state.editConcept.conceptoId;
          this.itemToDelete = item;

          break;

        default:
          break;
      }
    },
    deleteItem() {
      concepts.commit("setItemDelete", this.itemToDelete);
      concepts
        .dispatch("deleteSalarie")
        .then(() => {
          this.openDeleteSalaries = false;
          concepts.commit("setOpenDeleteSalaries", false);
          this.showAlert(this.$tc("concepts.deleteSalarieSuccess"), "#82A1D0");
        })
        .catch((e) => {
          this.showAlert(e, "#ff8d58");
        });
    },

    cancelDelete() {
      this.openDeleteSalaries = false;
      concepts.commit("setOpenDeleteSalaries", false);
    },

    async openDialogLiquidations(type, item) {
      this.typeForm = type;

      switch (this.typeForm) {
        case "add":
          this.selectDataLiquidations[0].readonly = true;
          concepts.commit(
            "setModeLiquidations",
            this.$tc("concepts.addLiquidation")
          );
          concepts.commit("setOpenLiquidations", true);
          break;
        case "edit":
          this.selectDataLiquidations[0].data = item.id;
          concepts.commit(
            "setModeLiquidations",
            this.$tc("concepts.editLiquidation")
          );
          this.itemId = item.id;
          this.originalData = { ...item };

          this.selectDataLiquidations[0].readonly = true;
          if (item.auth === "") {
            this.checkAuthLiquidations[0].data = false;
            this.originalData.auth = "false";
          } else {
            this.checkAuthLiquidations[0].data = true;
            this.originalData.auth = "true";
          }
          concepts.commit(
            "setModeLiquidations",
            this.$tc("concepts.editLiquidation")
          );
          concepts.commit("setOpenLiquidations", true);
          break;
        case "delete":
          concepts.commit("setOpenDeleteLiquidations", true);
          item.conceptoId = concepts.state.editConcept.conceptoId;
          this.itemToDelete = item;

          break;

        default:
          break;
      }
    },
    buildPayloadLiquidation(formData) {
      let payload = {
        id: Number(formData.liqModelos),
      };
      if (formData.auth === "true") {
        payload.auth = true;
      } else {
        payload.auth = false;
      }
      return payload;
    },
    addLiquidation(items) {
      let payload = this.buildPayloadLiquidation(items);
      payload.conceptoId = concepts.state.editConcept.conceptoId;
      concepts.commit("setNewConcept", payload);
      concepts
        .dispatch("addLiquidation")
        .then(() => {
          concepts.commit("setOpenLiquidations", false);
          this.showAlert(this.$tc("concepts.addSalarieSuccess"), "#82A1D0");
        })
        .catch((e) => {
          concepts.commit("setOpenLiquidations", false);
          this.showAlert(this.$tc("concepts.addSalarieError"), "#ff8d58");
        });
      this.reset(false);
    },
    sendEditLiquidation(updatedItem) {
      concepts.commit("setEditLiquidations", updatedItem);

      concepts
        .dispatch("editLiquidation")
        .then(() => {
          concepts.commit("setOpenSalaries", false);
          this.showAlert(
            this.$tc("concepts.editLiquidationSuccess"),
            "#82A1D0"
          );
        })
        .catch((e) => {
          concepts.commit("setOpenSalaries", false);
          this.showAlert(
            this.$tc("concepts.editLiquidationAlerteditLiquidationError"),
            "#ff8d58"
          );
        });

      this.reset(false);
    },
    editLiquidation(items) {
      const changes = {};
      const newAuthValue = items.auth || "false";

      if (newAuthValue !== this.originalData.auth) {
        changes.auth = newAuthValue;
      }

      if (Object.keys(changes).length > 0) {
        const updatedItem = { ...items, ...changes };
        updatedItem.conceptId = concepts.state.editConcept.conceptoId;
        this.sendEditLiquidation(updatedItem);
      } else {
        concepts.commit("setOpenLiquidations", false);
        this.showAlert(this.$tc("concepts.editLiquidationAlert"), "#f1c232");
      }
    },

    resetLiquidation() {
      concepts.commit("setModeLiquidations", "");
      concepts.commit("setOpenLiquidations", false);
      this.selectDataLiquidations[0].data = [];
    },

    deleteItemLiquidation() {
      concepts.commit("setItemDeleteLiquidations", this.itemToDelete);

      concepts
        .dispatch("deleteLiquidation")
        .then(() => {
          this.openDeleteLiquidations = false;
          concepts.commit("setOpenDeleteLiquidations", false);
          this.showAlert(
            this.$tc("concepts.deleteLiquidationSuccess"),
            "#82A1D0"
          );
        })
        .catch((e) => {
          this.openDeleteLiquidations = false;
          concepts.commit("setOpenDeleteLiquidations", false);
          this.showAlert(e, "#ff8d58");
        });
    },

    cancelDeleteLiquidation() {
      this.openDeleteLiquidations = false;
      concepts.commit("setOpenDeleteLiquidations", false);
    },
  },
};
</script>

<style scoped>
.form-container {
  display: flex;
  flex-direction: column;
}
.small {
  font-size: medium;
}
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}
.bt-previous {
  background-color: #737373 !important;
  color: white !important;
}
.bt-next {
  background-color: #39537a !important;
  color: white !important;
}
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}

.container-buttons {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap !important;
  margin-top: auto;
}

.scrollable-list {
  max-height: 300px;
  overflow-y: auto;
}
</style>
